/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import HeaderProfile from '../../components/header_Profile/header_Profile.index';
import CycleOverviewList from '../../components/CycleOverViewList/CycleOverviewList';
import { Box } from '@mui/material';
import { getStoredPermissions } from '../../utils/commonUtils';
import { CycleOverviewPermission } from '../../components/CycleOverViewList/CycleOverviewListHelper';
import NoAccessPage from '../noAccessPage';

interface PatientData {
  id: number;
  gender: 'MALE' | 'FEMALE';
  age: number;
  nameTitle: string;
  firstName: string;
  lastName: string;
  cycleNo: string;
  mrNo: string;
  updatedDatetime: Date;
  LastModified: string;
  visitID: string;
  genderId: string;
  visitedDoctorID: string;
  therapyId: string;
}

const CycleOverview = () => {
  const [selectedPatient, setSelectedPatient] = useState<PatientData | null>(null);

  const handleDataFromHeader = (data: PatientData) => {
    setSelectedPatient(data);
  };

  const allowedCycleOverviewPermissions: CycleOverviewPermission | { type: [] } = React.useMemo(() => {
    const permissionsData = getStoredPermissions();
    const clinicalModule = permissionsData?.modules?.find(
      (m: any) => m.name === 'Clinical' && m.featureEnabled
    );
    if (!clinicalModule) return { type: [] };
    const TreatmentModule = clinicalModule.submodules.find(
      (sm: any) => sm.name === 'Cycle Overview'
    );
    return TreatmentModule || { type: [] };
  }, []);


  // Permission logic for Cycle Overview
  let canShowCycleOverview = false;
  if (selectedPatient?.id && Array.isArray(allowedCycleOverviewPermissions.type) && allowedCycleOverviewPermissions.type.length > 0) {
    const cycleType = allowedCycleOverviewPermissions.type[0];
    if (selectedPatient.gender === 'FEMALE' && cycleType.female === true) {
      canShowCycleOverview = true;
    }
    if (selectedPatient.gender === 'MALE' && cycleType.male === true) {
      canShowCycleOverview = true;
    }
  }

  return (
    <div>
      <div>
        <HeaderProfile onData={handleDataFromHeader} />
      </div>
      <Box mt={4} px={2}>
        {selectedPatient?.id ? (
          canShowCycleOverview ? (
            <CycleOverviewList gender={selectedPatient.gender} />
          ) : (
            <NoAccessPage />
          )
        ) : null}
      </Box>
    </div>
  );
};

export default CycleOverview;
